import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';
import addCookieWithConsent from '../../utilities/addCookieWithConsent';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Add content to a component's draft
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestAuthenticateDemo = packet => {
  return {
    type: 'REQUEST_AUTHENTICATE_DEMO',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveAuthenticateDemoSuccess = data => ({
  type: 'RECEIVE_AUTHENTICATE_DEMO_SUCCESS',
  data
})

export const receiveAuthenticateDemoFail = data => ({
  type: 'RECEIVE_AUTHENTICATE_DEMO_FAIL',
  data
})

export const tryToAuthenticateDemo = packet => (dispatch, getState) => {

  dispatch(requestAuthenticateDemo(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  

  
  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  let demoAuth = Cookies.get(process.env.REACT_APP_COOKIE_DEMO_AUTH)
  if(demoAuth){
    headers["X-demo-auth"] = demoAuth;
  }

  return fetch('/api/components/demo/auth/' + packet.id + '/' + packet.version, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveAuthenticateDemoSuccess(json));
      addCookieWithConsent(process.env.REACT_APP_COOKIE_DEMO_AUTH, json.token, dispatch, 1, true);
      window.location.reload();

    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveAuthenticateDemoFail({errors:e, lastSubmit: packet}));
    })
}
